import React from 'react';
import SliderSlick from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styles.scss';
import Icon, { NextArrowIcon, PreArrowIcon } from 'components/Atoms/Icon';
import cn from 'classnames';

const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <Icon className={className} onClick={onClick} component={NextArrowIcon} />
  );
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <Icon className={className} onClick={onClick} component={PreArrowIcon} />
  );
};

const Slider = ({ className, settingProps, children }) => {
  const settings = {
    dots: false,
    speed: 500,
    swipeToSlide: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    ...settingProps,
  };

  return (
    <div className={cn('slider-wrapper', className)}>
      <SliderSlick {...settings}>{children}</SliderSlick>
    </div>
  );
};

export default Slider;
